document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-pp2-shop-filter]").forEach((root) => {
    const chips = Array.from(root.querySelectorAll("[data-pp2-filter]"));
    const cards = Array.from(root.querySelectorAll("[data-pp2-category]"));

    chips.forEach((chip) => {
      chip.addEventListener("click", () => {
        const cat = chip.dataset.pp2Filter;

        chips.forEach((c) => c.classList.toggle("is-active", c === chip));

        cards.forEach((card) => {
          const show = cat === "all" || card.dataset.pp2Category === cat;
          card.style.display = show ? "flex" : "none";
        });
      });
    });
  });
});
